import { request, jsonOptions, uploadFormData } from './client';

export const messagingApi = {
  conversations:  () => request('/messages/conversations'),
  unreadSummary:  () => request('/messages/unread-summary'),
  findOrCreate:   (userId) => request('/messages/conversations', jsonOptions('POST', { userId })),
  createGroup:    (name, members) => request('/messages/groups', jsonOptions('POST', { name, members })),

  messages:       (id) => request(`/messages/conversations/${id}/messages`),
  // body / attachments / replyTo — any of body or attachments must
  // be present.
  send:           (id, { body = '', attachments = [], replyTo } = {}) =>
    request(`/messages/conversations/${id}/messages`, jsonOptions('POST', { body, attachments, replyTo })),

  markRead:       (id) => request(`/messages/conversations/${id}/read`, { method: 'PATCH' }),
  hide:           (id) => request(`/messages/conversations/${id}/hide`, { method: 'PATCH' }),
  toggleMute:     (id, muted)  => request(`/messages/conversations/${id}/mute`, jsonOptions('PATCH', { muted })),
  togglePin:      (id, pinned) => request(`/messages/conversations/${id}/pin`,  jsonOptions('PATCH', { pinned })),

  renameGroup:    (id, name)       => request(`/messages/conversations/${id}/name`, jsonOptions('PATCH', { name })),
  addMember:      (id, userId)     => request(`/messages/conversations/${id}/members`, jsonOptions('POST', { userId })),
  removeMember:   (id, userId)     => request(`/messages/conversations/${id}/members/${userId}`, { method: 'DELETE' }),

  editMessage:    (id, body)       => request(`/messages/${id}`,           jsonOptions('PATCH', { body })),
  reactMessage:   (id, emoji)      => request(`/messages/${id}/reactions`, jsonOptions('POST',  { emoji })),
  unreactMessage: (id)             => request(`/messages/${id}/reactions`, { method: 'DELETE' }),
  deleteMessage:  (id)             => request(`/messages/${id}`,           { method: 'DELETE' }),

  // Web uploads a File / Blob — same multipart shape as posts.
  uploadAttachment: (file, { kind, durationMs } = {}, onProgress) => {
    const form = new FormData();
    form.append('media', file, file.name || `attachment-${Date.now()}`);
    if (kind) form.append('kind', kind);
    if (durationMs) form.append('durationMs', String(durationMs));
    return uploadFormData('/messages/attachments', form, onProgress);
  }
};
